export default "__VITE_ASSET__CZVCp6Fe__"